import { getContaAcesso } from '../../config/Auth.js';

const INITIAL_STATE = {
    user: iniciar(),
};

function iniciar() {
    return getContaAcesso();
}

function setUser(state, action) {
    const newUser = action.value ? action.value : null;
    return { ...state, user: newUser };
}

function userReducer(state = INITIAL_STATE, action) {
    if (action.type === 'SETUSER') {
        return setUser(state, action);
    }
    return state;
}

export default userReducer;
